import React, { useContext } from 'react'
import { Switch } from 'react-router-dom'
import './assets/global.css'
import './app.css'
import Authentication from './components/authentication'
import { CustomizedSnackbars, ForgotPassword, Navigation } from './components'
import UserProfilePage from './pages/user-profile-page'
import DoseDetailsPage from './pages/dose-details-page'
import SignUp from './components/authentication/SignUp'
import MyCircleDetailPage from './pages/my-circle-detail-page'
import TodayDosePage from './pages/today-dose-page'
import PastDosesPages from './pages/past-doses-page'
import { PrivateRoute, PublicRoute } from './routes'
import { LandingPage } from './pages/landing-page'
import { HomePage } from './pages/home'
import { MyCircleSettings } from './pages/my-circle-settings'
import { AccountSettingsPage } from './pages/account-settings'
import { FirestoreContext } from './providers/firestore-provider'
import { NotFoundPage } from './pages/not-found-page'
import HelpAndSupportPage from './pages/help-and-support-page'
import MyCircleMembersPage from './pages/my-circle-members'

const RoutesView = () => {
  const { currentUser, username } = useContext(FirestoreContext)
  return (
    <div>
      <CustomizedSnackbars />
      {currentUser && username && <Navigation />}
      <Switch>
        {/* Authentication */}
        <PublicRoute exact path="/" component={LandingPage} />
        <PublicRoute exact path="/sign-in" component={Authentication} />
        <PublicRoute exact path="/sign-up" component={SignUp} />
        <PublicRoute exact path="/forgot-password" component={ForgotPassword} />
        {/* Tabs  */}
        {/* Home  */}
        <PrivateRoute exact path="/home" component={HomePage} />
        {/* Circles */}
        <PrivateRoute exact path="/my-circles/:id" component={MyCircleDetailPage} />
        <PrivateRoute
          exact
          path="/my-circles/:id/settings"
          component={MyCircleSettings}
        />
        {/* Doses */}
        {/* // TODO: To use when we add a dose with the floating button */}
        {/* <PrivateRoute exact path="/add-dose" component={AddDose} /> */}
        <PrivateRoute exact path="/doses/:id" component={DoseDetailsPage} />
        <PrivateRoute
          exact
          path="/my-circles/:id/today-dose"
          component={TodayDosePage}
        />
        <PrivateRoute
          exact
          path="/my-circles/:id/past-doses"
          component={PastDosesPages}
        />
        <PrivateRoute
          exact
          path="/my-circles/:id/members"
          component={MyCircleMembersPage}
        />
        <PrivateRoute
          exact
          path="/my-circles/:circleId/doses/:doseId"
          component={DoseDetailsPage}
        />
        {/* Settings */}
        <PrivateRoute exact path="/profile" component={UserProfilePage} />
        <PrivateRoute
          exact
          path="/account-settings"
          component={AccountSettingsPage}
        />
        <PublicRoute exact path="/help-and-support" component={HelpAndSupportPage} />
        {/* Redirect */}
        <PrivateRoute path="*" component={NotFoundPage} />
      </Switch>
    </div>
  )
}

const App = () => <RoutesView />

export default App
